<template>
    <v-data-table v-bind="{ items, headers }" hide-default-footer disable-filtering disable-sort disable-pagination :items-per-page="-1">
        <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>

        <template #[`item.attendances`]="{ value }"> {{ value.length }} / {{ units.length }} </template>

        <template #[`item.actions`]="{ item }">
            <program-attendee-attendances v-bind="{ ...item, units }">
                <template #activator="{ attrs, on }">
                    <v-btn text icon tile v-bind="attrs" v-on="on"> <v-icon>mdi-eye</v-icon> </v-btn>
                </template>
            </program-attendee-attendances>
        </template>
    </v-data-table>
</template>

<script>
import api from "@/api";

import ProgramAttendeeAttendances from "./program-attendee-attendances.vue";
import { PROGRAM_APPLICATION_STATES } from "@/assets/variables";

let headers = [
    { width: 140, divider: true, text: "아이디", value: "user.username" },
    { width: 120, divider: true, text: "이름", value: "applicant.name" },
    { width: 240, divider: true, text: "학교/학과/과정", value: "applicantAffiliation", cellClass: "white-space-pre-line caption" },
    { width: 120, divider: true, text: "국가연구자번호", value: "applicant.researcherNo" },
    { width: 120, divider: true, text: "생년월일", value: "applicant.bornAt", formatter: (value) => (value ? value?.toDate?.() || value || "-" : value || "-") },
    { width: 200, divider: true, text: "연락처", value: "applicantContactInfo", cellClass: "white-space-pre-line caption" },
    { width: 100, divider: true, text: "출석현황", value: "attendances" },
    { width: +80, align: "right", text: "", value: "actions" },
];

export default {
    components: {
        ProgramAttendeeAttendances,
    },
    props: {
        program: { type: Object, default: () => ({}) },
    },
    data: () => ({
        applications: [],
        attendances: [],

        headers,
    }),
    computed: {
        items() {
            return this.applications.map((application = {}) => {
                let attendances = this.attendances.filter(({ _user }) => _user == application._user) || [];

                let { affiliation, department, courseName, phone, email } = application.applicant || {};
                let applicantAffiliation = `${affiliation || "-"}\n${department || "-"} / ${courseName || "-"}`;
                let applicantContactInfo = `${phone || "-"}\n${email || "-"}`;

                return {
                    ...application,
                    attendances,
                    applicantAffiliation,
                    applicantContactInfo,
                };
            });
        },
        units() {
            return this.program?.units || [];
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        "program._id"() {
            this.init();
        },
    },
    methods: {
        async init() {
            let { _id: _program } = this.program || {};

            if (_program) {
                let { applications } = await api.console.programs.applications.gets({ _program, params: { state: PROGRAM_APPLICATION_STATES.APPROVED.value } });
                this.applications = applications;
                let { attendances } = await api.console.programs.attendances.gets({ _program });
                this.attendances = attendances;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .white-space-pre-line {
    white-space: pre-line;
}
</style>